import React from "react"
import Flickity from "react-flickity-component"

interface ProductCarouselProps {
  products: Product[]
}

interface Product {
  image: string,
  title: string,
  description: string,
  url?: string,
  color: string
}

class ProductCarouselInner extends React.Component<ProductCarouselProps> {
  static defaultProps: ProductCarouselProps = {
    products: [],
  }

  isDesktop() {
    return !matchMedia("screen and (max-width: 576px)").matches
  }

  renderProduct(item: Product, index: number) {
    const url = item.url ? item.url : "/join"
    return (
      <div className="w-auto mb-2 p-4 flex" key={index}>
        <article className="flex flex-col shadow-[0_4px_8px_0px_rgba(0,0,0,0.2)] bg-white text-white">
          <a href={url} className="relative hover:ring-4 rounded-[8px]" style={{ "--tw-ring-color": item.color } as React.CSSProperties}>
            <img alt={item.title} src={item.image} className="rounded-[8px]" />
            <span className="absolute bottom-0 p-6 pt-48 rounded-b-[8px]" style={{ backgroundImage: "linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)" }}>
              <span className="flex flex-col items-start h-[85px]">
                <h3 className="text-lg font-bold">{item.title}</h3>
                <p className="text-sm/4">{item.description}</p>
              </span>
            </span>
          </a>
        </article>
      </div>
    )
  }

  render() {
    const { products } = this.props
    const options = {
      wrapAround: true,
      initialIndex: 2,
      prevNextButtons: this.isDesktop(),
    }

    return (
      <Flickity options={options}>
        { products.map(this.renderProduct) }
      </Flickity>
    )
  }
}

export function ProductCarousel(props: ProductCarouselProps) {
  return <ProductCarouselInner {...props} />
}
